export default __webpack_public_path__ + "static/media/booking-no-input.dea52230.svg";